import { fg } from '@atlassian/jira-feature-gating';
import {
	TARGET_START_DATE_FIELD,
	type DateField,
	type PlanInfo,
	DATEFIELD_TYPES,
} from './types.tsx';

export const extractDefaultStartDateField = (planInfo: PlanInfo): DateField => {
	const startDateCustomField = planInfo.customFields.find(
		(field) => field.defaultStartDateCustomField,
	);
	if (!startDateCustomField) {
		if (fg('sentry_fixes_for_plans')) {
			// Theoretically the Start date field should always be present as it's a locked
			// system field that's used by Project Timeline. However, in the case that it isn't
			// e.g support unlocked field and deleted it, we should gracefully handle this by
			// falling back to the built in Target Start date field.
			return TARGET_START_DATE_FIELD;
		}
		throw new Error('missing Start Date Custom field in server response');
	}
	return {
		id: `customfield_${startDateCustomField.id}`,
		key: `${startDateCustomField.id}`,
		type: DATEFIELD_TYPES.CUSTOM,
	};
};
